<template>
  <v-navigation-drawer v-model="drawer" app dark temporary>
    <v-list>
      <v-list-tile 
          v-for="(link, i) in links" :key="i"
          :to="link.to"
          :href="link.href"
          @click="$vuetify.goTo(link.href, options)" >
        <v-list-tile-title v-text="link.text" />
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import * as easings from 'vuetify/es5/util/easing-patterns'
export default {
  name: 'Drawer',
  props:['drawer'],
      data () {
          return {
            easings: Object.keys(easings),
            links: [
              {text: 'Про артиста', href: '#about'},
              {text: 'Фотогалерея', href: '#gallery'},  
              {text: 'Преса', href: '#pressa'}, 
              {text: 'Відео', href: '#videos'},
              {text: 'Контакти', href: '#contacts'}                                                 
            ]
          }
        },
  computed: {
    target () {
      const value = this[this.type]
        if (!isNaN(value)) return Number(value)
        else return value
      },
    options () {
      return {
        duration: 900,
        offset: 0,
        easing: 'easeInOutCubic'        
      }
    }
  }
}
</script>